// extracted by mini-css-extract-plugin
module.exports = {"desc":"desc-bPdsF5wsXB","policyTitle":"policyTitle-tI7hUSFcU4"};